<template> 
  <div 
  class="d-flex flex-column custom-back" style="background: linear-gradient(rgba(254, 187, 57, 0.3), rgba(15, 86, 128, 0.1)); height: 100vh;">
    <div class="d-flex flex-column flex-root align-items-stretch h-100">

      <div class="pt-10" style="max-height: 90vh; overflow-y: auto; flex: 1 1 auto; padding-right: 1rem;">
        
        <section class="hero-section sen-win">
          <div class="hero-content">
            <img class="hero-logo" src="/public/assets/media/RBL-logo.png" alt="Rebrand Leadership Logo">
          </div>
        </section>

        <div class="d-flex my-3" v-if="!showForm">
          <section class="card shadow-sm pt-5 px-5 mb-10 event-header border-topYellow sen-win">
            <h2 class="event-title mb-5 text-uppercase fs-2hx">
              {{ "INSCRIPTION RE-BRAND : YOUR LEADERSHIP EDITION 5" }}
            </h2>
            
            <div class="event-description" >
              <section style="padding: 2rem; border-radius: 8px; text-align: center; font-family: Arial, sans-serif;">
                <h2 class="fw-bold fs-3x">🙏 Merci pour votre participation</h2>
                <p class="fs-1 fw-bold" >
                  Nous vous remercions sincèrement d’avoir pris le temps de répondre à ce questionnaire.
                </p>
                <p class="fs-2 fw-normal" >
                  Votre contribution est précieuse. Elle nous permettra de mieux vous préparer une très belle expéreince
                </p>
                <p class="fs-2 fw-normal" style="color: #888; font-size: 0.9rem; margin: 1rem auto;">
                  Vos réponses sont reçues et traitées avec la plus grande confidentialité.
                </p>
              </section>
            </div>
          </section>
        </div>

        <div class="d-flex justify-content-center" v-if="showForm">
            <div class="mb-5 sen-win" >
                <GoogleFormPreview :event="event?.id" @close="showForm = false"/>
            </div>
        </div>
      </div>
      

      <div class="footer bg-white py-7" id="kt_footer" style="position: fixed; bottom: 0; left: 0; right: 0; z-index: 1000; width: 100%;">
        <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-center">
          <div class="text-dark order-2 order-md-1 fs-2">
            <span>{{ $t('powered') }}
              <a class="text-hover-primary" target="_blank" href="https://netbyus.com">{{ $t('poweredby') }}</a>
            </span>
            <span class="px-2">©{{ new Date().getFullYear() }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import Button from "@/components/Button";
  import Input from "@/components/Input.vue";
  import { ref, onMounted } from "vue"; 
  import {useStore} from "vuex";
  import {useRoute} from "vue-router";
  import GoogleFormPreview from "../../components/GoogleFormPreview.vue";
  import RequiredText from "@/components/RequiredText.vue";

  
  const store = useStore()
  const route = useRoute()

  const showForm = ref(true)
  const event = ref({})




  async function showEvent() {
      await store.dispatch('events/getEventDetailForParticipator', route.params.id).then((res) => {
        event.value = res.data?.data
      })
  }

  onMounted(() => {
    showEvent()
    showForm.value = true
  })
</script>

<style scoped>
  .text-gray {
    color: var(--bs-gray);
  }
  .center_vertical {
    width: 80%;
    margin: 0 auto !important;
    padding-top: 3rem;
  }

  .chat_fixed {
    position: fixed;
    right: 2rem;
    bottom: 7rem;
    cursor: pointer !important;
  }

  .form_fixed {
    position: fixed;
    right: 2rem;
    bottom: 11rem;
    width: 300px; 
    height: 350px;
  }

  .italic-text {
    font-style: italic;
  }

  .btn.btn-orange {
    color: #fff;
    border-color: var(--bs-warning) !important;
    background-color: var(--bs-warning) !important;
  }

  .single-digit {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    background-color: rgba(0, 33, 119, 0.3);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    min-width: 90px !important;
    height: 100px !important;
    position: relative;
  }

  .time-label {
    font-size: 12px !important;
    line-height: 1;
    margin-top: 5px;
    font-weight: 500;
  }

  .time-number {
    font-size: 50px !important;
    line-height: 1;
    font-weight: 500;
  }

  .h1_style {
    font-size: 75px !important; 
    margin-bottom: 2rem;
  }

  .p_style {
    font-size: 20px !important; 
    width: 90% !important;
  }

  .span_style {
    font-size: 10px !important; 
    width: 88% !important;
    margin-bottom: 2rem; 
    cursor: pointer;
    margin-right: 5rem !important;
  }

  .timer {
    width: 200px !important; 
    margin-bottom: 8rem;
  }

  .fs-18 {
    font-size: 18px !important;
  }

  .address {
    margin-bottom: 3rem; 
    display: flex;
  }

  .img_top {
    width: 60px; 
    height: 60px; 
    border-radius: 1rem; 
    margin-bottom: 2rem;
  }

  .img_top img {
    width: 42px;
  }

  .truncate-text {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .background-container {
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .background-container::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 33, 119, 0.45);
    z-index: 0;
  }

  .background-container > * {
    position: relative;
    z-index: 1;
  }

  .form_style {
    font-size: 13px !important;
    cursor: pointer !important; 
    width: 350px !important;
  }

  @media (max-width: 768px) {
    .center_vertical {
      padding-top: 1.5rem !important;
    }

    .h1_style {
      font-size: 30px !important; 
    }

    .p_style {
      font-size: 15px !important;
      width: 100% !important;
    }

    .span_style {
      font-size: 10px !important; 
      width: 100% !important;
    }

    .timer {
      width: 100px !important; 
    }

    .single-digit {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      background-color: rgba(0, 33, 119, 0.3);
      border-radius: 5px;
      padding: 5px;
      color: #fff;
      min-width: 60px !important;
      height: 80px !important;
      position: relative;
    }

    .time-label {
      font-size: 9px !important;
      line-height: 1;
      margin-top: 5px;
    }

    .time-number {
      font-size: 30px !important;
      line-height: 1;
    }

    .fs-18 {
      font-size: 12px !important;
    }

    .address {
      display: block;
    }

    .address .fs-18 {
      font-size: 15px !important;
    }

    .img_top {
      width: 40px; 
      height: 40px; 
      border-radius: 1rem; 
    }

    .img_top img {
      width: 25px;
    }

    .form_style {
      font-size: 10px !important;
      width: 300px !important;
    }

    .mobile_img {
      height: 200px !important;
      margin-top: -80px !important;
      margin-bottom: 10px !important;
    }
  }

  .hero-section {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60%; 
    height: 20%;            
    margin: 20px auto 10px auto;   
    padding: 20px;          
    background-color: #FEBB39;
    border-radius: 12px;   
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    text-align: center;
  }

  .sen-win {
    
      width: 90%;                  
  }

@media (min-width: 992px) {
    .sen-win {
        width:60%;
        height: auto;
    }
    .event-header{
      width: 60% !important;
    }
}


  .hero-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .hero-logo {
    max-width: 200px; 
    width: 100%; 
    height: auto; 
    object-fit: contain;
  }


  .event-header {
  
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;     height: 20%;            
    margin: 15px auto 30px auto;       
    border-radius: 12px;   
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    text-align: center;
  }

  .border-topYellow{
  border-top: #FEBB39 10px solid;
  border-radius: 12px;

  }

  .event-title {
    margin-top: 12px;
    font-weight: 800;
    color: #333333;
    text-align: left;
  }

  .event-description {
    font-size: 1em;
    line-height: 1.6;
    color: #555555;
    text-align: left;
  }

  .section-divider {
      border: none;
      border-top: 3px solid #FFD700; 
      width: 35%; 
      margin: 20px 0 20px 0; 
  }


  .form-selection-card {
    border-radius: 8px;
    padding: 40px;
  }

  .title-form-selection {
    font-weight: 700;
    color: #333333;
  }

  .form-list {
      gap: 15px; 
  }

  .form-item {
    cursor: pointer;
    min-height: 50px;
    min-width: 150px;
    transition: all 0.3s ease;
    user-select: none; 
  }

  .form-item:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .description-text {
    padding-bottom: 8px;
  }


  @media (max-width: 992px) {
      .event-title {
          font-size: 1.5em; 
      }
      .form-selection-card {
          padding: 20px;
      }
      .form-item {
          margin: 10px 5px !important; 
          padding: 15px 20px !important;
      }
  }



  @media (max-width: 768px) {
    .hero-section {
      height: 250px;
    }

    .hero-logo {
      max-width: 150px; 
    }

    .main-content-wrapper {
          width: 95%; 
      }
      .event-header {
          padding: 20px;
      }
      .event-title {
          font-size: 1.2em;
          text-align: center;
      }
      .section-divider {
          margin-left: auto;
          margin-right: auto;
      }
      .event-description {
          font-size: 0.9em;
      }
      .title-form-selection {
          font-size: 1.5em;
      }
  }
</style>